import { Autocomplete, TextField } from '@mui/material';
import { TIMEZONE_OPTIONS, DEFAULT_TZ_OFFSET } from '../utils/timezone';

interface TimezoneSelectProps {
  value: number;
  onChange: (value: number) => void;
  sx?: object;
}

// Standalone report-timezone selector (sits in the filter row, alongside the date range).
export default function TimezoneSelect({ value, onChange, sx }: TimezoneSelectProps) {
  return (
    <Autocomplete
      size="small"
      sx={{ width: 150, ...sx }}
      options={TIMEZONE_OPTIONS}
      groupBy={(o) => o.group}
      getOptionLabel={(o) => o.label}
      value={TIMEZONE_OPTIONS.find((o) => o.value === value) || TIMEZONE_OPTIONS.find((o) => o.value === DEFAULT_TZ_OFFSET) || TIMEZONE_OPTIONS[0]}
      onChange={(_, v) => onChange(v?.value ?? DEFAULT_TZ_OFFSET)}
      disableClearable
      isOptionEqualToValue={(o, v) => o.value === v.value}
      renderInput={(params) => <TextField {...params} label="Timezone" />}
    />
  );
}
